var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFramedWallLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-4, .cls-5, .cls-6 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #f5f5f5;\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-6 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.33px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 0.46px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.79px;\r\n      }\r\n\r\n      .cls-7 {\r\n        font-size: 8.64px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconFramedWallLayer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Framed"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 72.91 140.38 69.68 140.38 66.94 134.62 70.17 134.62 72.05 134.62 72.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 72.91 134.62 70.17 115.45 63.27 115.45 66.01 127 70.17 134.62 72.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 70.17 140.38 66.94 121.22 60.04 115.45 63.27 134.62 70.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.13 52.22 77.13 49.47 57.97 42.58 57.97 45.32 69.51 49.47 77.13 52.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "77.13 49.47 82.89 46.25 63.73 39.35 57.97 42.58 77.13 49.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.29 59.11 96.29 56.37 77.13 49.47 77.13 52.22 88.67 56.37 96.29 59.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.29 56.37 102.05 53.14 82.89 46.25 77.13 49.47 79.82 50.44 96.29 56.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "96.29 144.14 96.29 141.4 83.9 136.93 84.53 139.91 95.1 143.71 96.29 144.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.1 140.97 95.1 135.66 84.09 131.7 83.15 132.23 83.9 136.93 90.57 139.34 95.1 140.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.45 151.04 115.45 148.29 96.29 141.4 96.29 144.14 114.26 150.6 115.45 151.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.26 147.86 114.26 142.56 103.25 138.6 97.49 141.83 111.89 147.01 114.26 147.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 155.19 134.62 103.08 132.22 102.22 132.22 154.33 134.62 155.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 155.19 140.38 151.96 140.38 99.85 134.62 103.08 134.62 147.01 134.62 155.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 103.08 134.62 72.91 132.22 72.05 132.22 102.22 134.62 103.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 103.08 140.38 99.85 140.38 69.68 134.62 72.91 134.62 100.21 134.62 103.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "60.37 66.79 60.37 46.18 57.97 45.32 57.97 65.93 60.37 66.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "65.19 72.28 66.13 71.75 66.13 48.25 60.37 46.18 60.37 66.79 61.92 67.35 64.84 71.75 65.19 72.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.94 83.33 75.94 80.58 69 78.09 71.05 81.45 71.14 81.6 75.35 83.12 75.94 83.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.94 80.58 75.94 75.28 66.13 71.75 65.19 72.28 69 78.09 72.7 79.42 75.94 80.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.1 90.22 95.1 87.48 78.33 81.45 78.33 84.19 87.48 87.48 95.1 90.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "95.1 87.48 95.1 82.18 84.09 78.22 78.33 81.45 84.09 83.52 95.1 87.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.26 97.12 114.26 94.38 97.49 88.34 97.49 91.09 106.64 94.38 114.26 97.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.26 94.38 114.26 89.08 103.25 85.12 97.49 88.34 103.25 90.42 114.26 94.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.33,97.47V82.82L75.93,82v9.28l1,2.41L78.15,97Zm0,7.33v-1.29l-1.4.79.59.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "83.15 132.23 84.09 131.7 84.09 86.26 78.33 84.19 78.33 97.47 78.57 98.12 79.91 102.63 78.33 103.51 78.33 104.8 80.66 105.64 81.5 109.86 82.09 114.05 82.43 118.18 82.64 126.91 83.06 131.66 83.15 132.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.49 141.83 97.49 89.72 95.1 88.85 95.1 140.97 96.29 141.4 97.49 141.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.49 141.83 103.25 138.6 103.25 93.16 97.49 91.09 97.49 141.4 97.49 141.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.33 82.82 78.33 52.65 75.94 51.78 75.94 81.95 76.84 82.28 78.33 82.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.33 81.45 84.09 78.22 84.09 54.72 78.33 52.65 78.33 79.59 78.33 81.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.49 89.72 97.49 59.55 95.1 58.68 95.1 88.85 96.29 89.28 97.49 89.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "97.49 88.34 103.25 85.12 103.25 61.62 97.49 59.55 97.49 86.49 97.49 88.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.45 66.01 115.45 63.27 96.29 56.37 96.29 59.11 107.84 63.27 115.45 66.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.45 63.27 121.22 60.04 102.05 53.14 96.29 56.37 115.45 63.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 157.93 140.38 154.71 140.38 151.96 134.62 155.19 134.62 157.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.62 157.93 134.62 155.19 115.45 148.29 115.45 151.04 127 155.19 134.62 157.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.22 154.33 132.22 149.03 122.41 145.5 116.65 148.72 122.41 150.8 132.22 154.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.22 103.59 132.22 100.84 116.65 95.24 116.65 97.98 130.81 103.08 132.22 103.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.22 100.84 132.22 95.55 122.41 92.01 116.65 95.24 130.46 100.21 132.22 100.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.65 148.72 116.65 96.61 114.26 95.75 114.26 147.86 115.45 148.29 116.65 148.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.65 148.72 122.41 145.5 122.41 100.06 116.65 97.98 116.65 148.29 116.65 148.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.65 96.61 116.65 66.44 114.26 65.58 114.26 95.75 115.45 96.18 116.65 96.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.65 95.24 122.41 92.01 122.41 68.52 116.65 66.44 116.65 93.39 116.65 95.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.42,96V67.2L32.85,61.6V90.4l7.62,2.74Zm19.16,6.9V87.24l-2.19-3.89L63,79.57,56.8,70.22l-6-2.16v28.8l9.3,3.35Zm7.21,2.6-1.62-5.29-1.33-3.69L70,92.11v11.65L73.45,105Zm-26.37,44V98.74l-15.57-5.6v50.74l8.7,3.13Zm19.16,6.9V105.64l-16.77-6v50.74Zm19.16,6.9-2.17-4.68-1.9-4.76L81.05,149l-1.34-4.84-1-4.84L78,134.53l-.43-4.75-.21-8.73L77,116.91l-.59-4.18-.84-4.22-5.57-2v50.74l12.7,4.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.42 96 50.81 94.66 50.81 68.06 53.53 66.54 53.53 64.33 48.42 67.2 48.42 95.88 48.42 96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.42 67.2 53.53 64.33 37.97 58.73 32.85 61.6 48.42 67.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.42 149.48 50.81 148.14 50.81 99.61 53.53 98.08 53.53 97.84 51.4 97.07 48.42 98.74 48.42 147.01 48.42 149.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.42 98.74 51.4 97.07 50.81 96.86 50.81 94.89 50.55 94.8 48.42 96 35.83 91.47 32.85 93.14 45.44 97.67 48.42 98.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.58 102.9 69.97 101.56 69.97 92.11 72.7 90.58 72.7 84.37 67.58 87.24 67.58 102.77 67.58 102.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "56.8 70.22 61.92 67.35 55.93 65.2 50.81 68.06 53.53 69.05 56.8 70.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.58 105.64 70.56 103.97 69.97 103.76 69.97 101.79 69.72 101.7 67.58 102.9 53.79 97.94 50.81 99.61 59.96 102.9 67.58 105.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.58 156.38 69.97 155.04 69.97 106.5 72.7 104.98 72.7 104.74 70.56 103.97 67.58 105.64 67.58 153.84 67.58 156.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "75.54 108.51 80.66 105.64 76.93 104.3 74.79 105.5 72.95 104.83 69.97 106.5 72.7 107.48 75.54 108.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "67.58 87.24 72.7 84.37 70.51 80.48 68.13 76.7 63.01 79.57 65.39 83.34 66.13 84.66 67.58 87.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "63.01 79.57 68.13 76.7 61.92 67.35 56.8 70.22 63.01 79.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "74.79 105.5 79.91 102.63 78.33 97.47 76.96 93.65 75.09 89.24 69.97 92.11 71.96 96.86 73.45 100.99 74.36 104.05 74.79 105.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.74 163.28 91.86 160.41 89.69 155.73 87.79 150.97 86.17 146.15 84.83 141.31 83.8 136.47 83.06 131.66 82.64 126.91 82.53 122.25 77.41 125.11 77.52 129.78 77.99 134.81 78.68 139.34 79.82 144.56 81.05 149.02 82.67 153.84 84.57 158.6 86.74 163.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.41 125.11 82.53 122.25 82.43 118.18 82.09 114.05 81.5 109.86 80.66 105.64 75.54 108.51 76.38 112.72 76.97 116.91 77.31 121.05 77.37 123.61 77.41 125.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 70.17,
    x2: 134.62,
    y2: 72.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 72.91,
    x2: 140.38,
    y2: 69.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 69.68,
    x2: 140.38,
    y2: 66.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 66.94,
    x2: 134.62,
    y2: 70.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 70.17,
    x2: 115.45,
    y2: 63.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 115.45,
    y1: 66.01,
    x2: 134.62,
    y2: 72.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 121.21,
    y1: 60.04,
    x2: 140.38,
    y2: 66.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.97,
    y1: 42.58,
    x2: 63.73,
    y2: 39.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.97,
    y1: 45.32,
    x2: 57.97,
    y2: 42.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.13,
    y1: 49.47,
    x2: 57.97,
    y2: 42.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.97,
    y1: 45.32,
    x2: 77.13,
    y2: 52.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 63.73,
    y1: 39.35,
    x2: 82.89,
    y2: 46.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 96.29,
    y1: 56.37,
    x2: 77.13,
    y2: 49.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.13,
    y1: 52.22,
    x2: 96.29,
    y2: 59.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 82.89,
    y1: 46.25,
    x2: 102.05,
    y2: 53.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.53,
    y1: 139.91,
    x2: 96.29,
    y2: 144.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 96.29,
    y1: 141.4,
    x2: 83.9,
    y2: 136.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.1,
    y1: 135.66,
    x2: 84.09,
    y2: 131.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 96.29,
    y1: 144.14,
    x2: 115.45,
    y2: 151.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 115.45,
    y1: 148.29,
    x2: 96.29,
    y2: 141.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.26,
    y1: 142.56,
    x2: 103.25,
    y2: 138.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 155.19,
    x2: 132.22,
    y2: 154.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 151.96,
    x2: 134.62,
    y2: 155.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 155.19,
    x2: 134.62,
    y2: 103.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.22,
    y1: 102.22,
    x2: 132.22,
    y2: 154.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 99.85,
    x2: 140.38,
    y2: 151.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 72.91,
    x2: 140.38,
    y2: 69.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.22,
    y1: 72.05,
    x2: 134.62,
    y2: 72.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 103.08,
    x2: 134.62,
    y2: 72.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.22,
    y1: 72.05,
    x2: 132.22,
    y2: 102.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 69.68,
    x2: 140.38,
    y2: 99.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.97,
    y1: 45.32,
    x2: 60.37,
    y2: 46.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 57.97,
    y1: 45.32,
    x2: 57.97,
    y2: 65.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 60.37,
    y1: 66.79,
    x2: 60.37,
    y2: 46.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.13,
    y1: 71.75,
    x2: 66.13,
    y2: 48.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.93,
    y1: 80.58,
    x2: 75.93,
    y2: 83.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 65.19,
    y1: 72.28,
    x2: 66.13,
    y2: 71.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.93,
    y1: 80.58,
    x2: 69,
    y2: 78.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 71.14,
    y1: 81.6,
    x2: 75.93,
    y2: 83.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.13,
    y1: 71.75,
    x2: 75.93,
    y2: 75.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.1,
    y1: 87.48,
    x2: 95.1,
    y2: 90.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.33,
    y1: 81.45,
    x2: 84.09,
    y2: 78.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.33,
    y1: 84.19,
    x2: 78.33,
    y2: 81.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.1,
    y1: 87.48,
    x2: 78.33,
    y2: 81.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.33,
    y1: 84.19,
    x2: 95.1,
    y2: 90.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.09,
    y1: 78.22,
    x2: 95.1,
    y2: 82.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.26,
    y1: 94.38,
    x2: 114.26,
    y2: 97.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.49,
    y1: 88.34,
    x2: 103.25,
    y2: 85.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.49,
    y1: 91.09,
    x2: 97.49,
    y2: 88.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.26,
    y1: 94.38,
    x2: 97.49,
    y2: 88.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.49,
    y1: 91.09,
    x2: 114.26,
    y2: 97.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.25,
    y1: 85.12,
    x2: 114.26,
    y2: 89.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.09,
    y1: 131.7,
    x2: 83.15,
    y2: 132.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.33,
    y1: 104.8,
    x2: 78.33,
    y2: 103.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.33,
    y1: 97.47,
    x2: 78.33,
    y2: 82.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.93,
    y1: 81.96,
    x2: 75.93,
    y2: 91.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.09,
    y1: 86.26,
    x2: 84.09,
    y2: 131.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.49,
    y1: 141.83,
    x2: 95.1,
    y2: 140.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.25,
    y1: 138.6,
    x2: 97.49,
    y2: 141.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.49,
    y1: 141.83,
    x2: 97.49,
    y2: 89.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.1,
    y1: 88.85,
    x2: 95.1,
    y2: 140.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.25,
    y1: 93.16,
    x2: 103.25,
    y2: 138.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.93,
    y1: 51.78,
    x2: 78.33,
    y2: 52.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.33,
    y1: 82.82,
    x2: 78.33,
    y2: 52.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.93,
    y1: 51.78,
    x2: 75.93,
    y2: 81.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 84.09,
    y1: 54.72,
    x2: 84.09,
    y2: 78.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.1,
    y1: 58.68,
    x2: 97.49,
    y2: 59.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 97.49,
    y1: 89.71,
    x2: 97.49,
    y2: 59.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 95.1,
    y1: 58.68,
    x2: 95.1,
    y2: 88.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 103.25,
    y1: 61.62,
    x2: 103.25,
    y2: 85.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 115.45,
    y1: 63.27,
    x2: 96.29,
    y2: 56.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 96.29,
    y1: 59.11,
    x2: 115.45,
    y2: 66.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 102.05,
    y1: 53.14,
    x2: 121.21,
    y2: 60.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 157.93,
    x2: 140.38,
    y2: 154.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 154.71,
    x2: 140.38,
    y2: 151.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 140.38,
    y1: 151.96,
    x2: 134.62,
    y2: 155.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 155.19,
    x2: 134.62,
    y2: 157.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 115.45,
    y1: 151.04,
    x2: 134.62,
    y2: 157.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 134.62,
    y1: 155.19,
    x2: 115.45,
    y2: 148.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.22,
    y1: 149.03,
    x2: 122.41,
    y2: 145.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.22,
    y1: 100.85,
    x2: 132.22,
    y2: 103.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.65,
    y1: 95.24,
    x2: 122.41,
    y2: 92.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.65,
    y1: 97.98,
    x2: 116.65,
    y2: 95.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 132.22,
    y1: 100.85,
    x2: 116.65,
    y2: 95.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.65,
    y1: 97.98,
    x2: 132.22,
    y2: 103.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.41,
    y1: 92.01,
    x2: 132.22,
    y2: 95.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.65,
    y1: 148.72,
    x2: 114.26,
    y2: 147.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.41,
    y1: 145.5,
    x2: 116.65,
    y2: 148.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.65,
    y1: 148.72,
    x2: 116.65,
    y2: 96.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.26,
    y1: 95.75,
    x2: 114.26,
    y2: 147.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.41,
    y1: 100.06,
    x2: 122.41,
    y2: 145.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.26,
    y1: 65.58,
    x2: 116.65,
    y2: 66.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.65,
    y1: 96.61,
    x2: 116.65,
    y2: 66.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 114.26,
    y1: 65.58,
    x2: 114.26,
    y2: 95.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.41,
    y1: 68.52,
    x2: 122.41,
    y2: 92.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.85,
    y1: 90.4,
    x2: 48.42,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 48.42,
    y1: 96,
    x2: 48.42,
    y2: 67.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 48.42,
    y1: 67.2,
    x2: 32.85,
    y2: 61.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.85,
    y1: 61.6,
    x2: 32.85,
    y2: 90.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 48.42,
    y1: 149.48,
    x2: 48.42,
    y2: 98.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 48.42,
    y1: 98.74,
    x2: 32.85,
    y2: 93.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.85,
    y1: 93.14,
    x2: 32.85,
    y2: 143.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.85,
    y1: 143.88,
    x2: 48.42,
    y2: 149.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.81,
    y1: 96.86,
    x2: 67.58,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.58,
    y1: 102.9,
    x2: 67.58,
    y2: 87.24
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "67.58 87.24 65.39 83.34 63.01 79.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 63.01,
    y1: 79.57,
    x2: 56.8,
    y2: 70.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.8,
    y1: 70.22,
    x2: 50.81,
    y2: 68.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.81,
    y1: 68.06,
    x2: 50.81,
    y2: 96.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 103.76,
    x2: 74.79,
    y2: 105.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "74.79 105.5 73.45 100.99 71.84 96.52 69.97 92.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 92.11,
    x2: 69.97,
    y2: 103.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.58,
    y1: 105.64,
    x2: 50.81,
    y2: 99.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.81,
    y1: 99.61,
    x2: 50.81,
    y2: 150.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.81,
    y1: 150.35,
    x2: 67.58,
    y2: 156.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.58,
    y1: 156.38,
    x2: 67.58,
    y2: 105.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 157.24,
    x2: 86.74,
    y2: 163.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "86.74 163.28 84.57 158.6 82.67 153.84 81.05 149.02 79.71 144.18 78.68 139.34 77.94 134.53 77.52 129.78 77.41 125.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "77.41 125.11 77.31 121.05 76.97 116.91 76.38 112.72 75.54 108.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.54,
    y1: 108.51,
    x2: 69.97,
    y2: 106.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 106.5,
    x2: 69.97,
    y2: 157.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.55,
    y1: 94.8,
    x2: 50.81,
    y2: 94.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.54,
    y1: 97.84,
    x2: 53.54,
    y2: 98.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 37.97,
    y1: 58.73,
    x2: 53.54,
    y2: 64.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.54,
    y1: 64.33,
    x2: 53.54,
    y2: 66.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55.93,
    y1: 65.2,
    x2: 61.92,
    y2: 67.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 61.92,
    y1: 67.35,
    x2: 68.13,
    y2: 76.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "68.13 76.7 70.51 80.48 72.7 84.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.7,
    y1: 84.37,
    x2: 72.7,
    y2: 90.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "75.09 89.24 76.96 93.65 78.57 98.12 79.91 102.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.7,
    y1: 104.74,
    x2: 72.7,
    y2: 104.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.72,
    y1: 101.7,
    x2: 69.97,
    y2: 101.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 76.93,
    y1: 104.3,
    x2: 80.66,
    y2: 105.64
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "80.66 105.64 81.5 109.86 82.09 114.05 82.43 118.18 82.53 122.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "82.53 122.25 82.64 126.91 83.06 131.66 83.8 136.47 84.83 141.31 86.17 146.15 87.79 150.97 89.69 155.73 91.86 160.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 32.85,
    y1: 61.6,
    x2: 37.97,
    y2: 58.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.81,
    y1: 94.66,
    x2: 48.42,
    y2: 96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.54,
    y1: 64.33,
    x2: 48.42,
    y2: 67.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 50.81,
    y1: 148.14,
    x2: 48.42,
    y2: 149.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 51.4,
    y1: 97.07,
    x2: 48.42,
    y2: 98.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 35.83,
    y1: 91.47,
    x2: 32.85,
    y2: 93.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 101.56,
    x2: 67.58,
    y2: 102.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 56.8,
    y1: 70.22,
    x2: 61.92,
    y2: 67.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 55.93,
    y1: 65.2,
    x2: 50.81,
    y2: 68.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 92.11,
    x2: 75.09,
    y2: 89.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.58,
    y1: 105.64,
    x2: 70.56,
    y2: 103.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.79,
    y1: 97.94,
    x2: 50.81,
    y2: 99.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.97,
    y1: 155.04,
    x2: 67.58,
    y2: 156.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.54,
    y1: 108.51,
    x2: 80.66,
    y2: 105.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.95,
    y1: 104.83,
    x2: 69.97,
    y2: 106.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.7,
    y1: 84.37,
    x2: 67.58,
    y2: 87.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 79.91,
    y1: 102.63,
    x2: 74.79,
    y2: 105.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 91.86,
    y1: 160.41,
    x2: 86.74,
    y2: 163.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 73.94,
    y1: 38.99,
    x2: 99.49,
    y2: 48.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 96.29,
    y1: 47.04,
    x2: 94.7,
    y2: 48.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 96.29,
    y1: 47.04,
    x2: 97.89,
    y2: 45.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 96.29,
    y1: 47.04,
    x2: 96.29,
    y2: 43.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 96.29,
    y1: 47.04,
    x2: 96.29,
    y2: 55.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 77.13,
    y1: 40.14,
    x2: 75.54,
    y2: 41.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 77.13,
    y1: 40.14,
    x2: 78.73,
    y2: 38.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 77.13,
    y1: 40.14,
    x2: 77.13,
    y2: 36.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 77.13,
    y1: 40.14,
    x2: 77.13,
    y2: 48.56
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.89 44.27 86.61 44.58 87.34 44.3 87.66 43.59 87.38 42.86 86.66 42.54 85.93 42.82 85.61 43.54 85.89 44.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "85.89 44.27 86.61 44.58 87.34 44.3 87.66 43.59 87.38 42.86 86.66 42.54 85.93 42.82 85.61 43.54 85.89 44.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "85.89 44.27 86.61 44.58 87.34 44.3 87.66 43.59 87.38 42.86 86.66 42.54 85.93 42.82 85.61 43.54 85.89 44.27"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 104.52,
    y1: 26.53,
    x2: 158.86,
    y2: 26.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 86.63,
    y1: 43.56,
    x2: 104.52,
    y2: 26.53
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.93 29.6)"
  }, "Spacing of Verticals"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.53,
    y1: 104.07,
    x2: 147.53,
    y2: 166.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 147.53,
    y1: 162.58,
    x2: 145.93,
    y2: 160.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 147.53,
    y1: 162.58,
    x2: 149.12,
    y2: 164.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.53,
    y1: 162.58,
    x2: 150.72,
    y2: 163.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.53,
    y1: 162.58,
    x2: 137.81,
    y2: 159.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 147.53,
    y1: 107.73,
    x2: 145.93,
    y2: 105.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 147.53,
    y1: 107.73,
    x2: 149.12,
    y2: 110.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.53,
    y1: 107.73,
    x2: 150.72,
    y2: 108.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.53,
    y1: 107.73,
    x2: 137.81,
    y2: 104.23
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.53 135.52 146.82 136.25 147.55 136.55 148.27 136.25 148.57 135.52 148.27 134.8 147.55 134.5 146.82 134.8 146.53 135.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "146.53 135.52 146.82 136.25 147.55 136.55 148.27 136.25 148.57 135.52 148.27 134.8 147.55 134.5 146.82 134.8 146.53 135.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "146.53 135.52 146.82 136.25 147.55 136.55 148.27 136.25 148.57 135.52 148.27 134.8 147.55 134.5 146.82 134.8 146.53 135.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 147.55,
    y1: 135.52,
    x2: 158.8,
    y2: 135.52
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.87 138.59)"
  }, "Spacing of Horizontals"), /*#__PURE__*/React.createElement("polygon", {
    points: "106.23 57.78 106.97 58.04 107.67 57.69 107.93 56.95 107.59 56.25 106.85 55.99 106.14 56.34 105.89 57.08 106.23 57.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "106.23 57.78 106.97 58.04 107.67 57.69 107.93 56.95 107.59 56.25 106.85 55.99 106.14 56.34 105.89 57.08 106.23 57.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "106.23 57.78 106.97 58.04 107.67 57.69 107.93 56.95 107.59 56.25 106.85 55.99 106.14 56.34 105.89 57.08 106.23 57.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 122.42,
    y1: 39.52,
    x2: 158.86,
    y2: 39.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 106.91,
    y1: 57.01,
    x2: 122.42,
    y2: 39.52
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.93 42.59)"
  }, "# Top Members"), /*#__PURE__*/React.createElement("polygon", {
    points: "58.89 52.77 59.63 53.02 60.33 52.67 60.58 51.93 60.23 51.23 59.49 50.98 58.79 51.32 58.54 52.06 58.89 52.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "58.89 52.77 59.63 53.02 60.33 52.67 60.58 51.93 60.23 51.23 59.49 50.98 58.79 51.32 58.54 52.06 58.89 52.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "58.89 52.77 59.63 53.02 60.33 52.67 60.58 51.93 60.23 51.23 59.49 50.98 58.79 51.32 58.54 52.06 58.89 52.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 92.3,
    y1: 14.54,
    x2: 158.86,
    y2: 14.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 59.56,
    y1: 52,
    x2: 92.3,
    y2: 14.54
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.93 17.61)"
  }, "# Left Members"), /*#__PURE__*/React.createElement("polygon", {
    points: "136.52 85.56 136.82 86.29 137.54 86.59 138.26 86.29 138.56 85.56 138.26 84.84 137.54 84.54 136.82 84.84 136.52 85.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "136.52 85.56 136.82 86.29 137.54 86.59 138.26 86.29 138.56 85.56 138.26 84.84 137.54 84.54 136.82 84.84 136.52 85.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "136.52 85.56 136.82 86.29 137.54 86.59 138.26 86.29 138.56 85.56 138.26 84.84 137.54 84.54 136.82 84.84 136.52 85.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 137.54,
    y1: 85.56,
    x2: 159.02,
    y2: 85.56
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(162.09 88.63)"
  }, "# Right Members"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 97.65,
    y1: 169.56,
    x2: 107.89,
    y2: 163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 105.33,
    y1: 165.26,
    x2: 105.65,
    y2: 166.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 105.33,
    y1: 165.26,
    x2: 105.01,
    y2: 163.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 105.33,
    y1: 165.26,
    x2: 108.52,
    y2: 166.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 105.33,
    y1: 165.26,
    x2: 95.05,
    y2: 161.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 100.21,
    y1: 168.13,
    x2: 100.53,
    y2: 169.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 100.21,
    y1: 168.13,
    x2: 99.89,
    y2: 166.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 100.21,
    y1: 168.13,
    x2: 103.4,
    y2: 169.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 100.21,
    y1: 168.13,
    x2: 89.93,
    y2: 164.43
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.97 166.44 101.97 167.22 102.52 167.78 103.31 167.78 103.86 167.23 103.86 166.44 103.31 165.89 102.53 165.89 101.97 166.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "101.97 166.44 101.97 167.22 102.52 167.78 103.31 167.78 103.86 167.23 103.86 166.44 103.31 165.89 102.53 165.89 101.97 166.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "101.97 166.44 101.97 167.22 102.52 167.78 103.31 167.78 103.86 167.23 103.86 166.44 103.31 165.89 102.53 165.89 101.97 166.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 139.34,
    y1: 181.99,
    x2: 158.8,
    y2: 181.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 102.92,
    y1: 166.84,
    x2: 139.34,
    y2: 181.99
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.87 185.06)"
  }, "Fill Thickness"), /*#__PURE__*/React.createElement("polygon", {
    points: "106.67 144.9 107.45 144.83 107.95 144.23 107.88 143.45 107.28 142.95 106.5 143.02 106 143.62 106.07 144.4 106.67 144.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "106.67 144.9 107.45 144.83 107.95 144.23 107.88 143.45 107.28 142.95 106.5 143.02 106 143.62 106.07 144.4 106.67 144.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "106.67 144.9 107.45 144.83 107.95 144.23 107.88 143.45 107.28 142.95 106.5 143.02 106 143.62 106.07 144.4 106.67 144.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 135.31,
    y1: 53.71,
    x2: 158.8,
    y2: 53.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 106.98,
    y1: 143.92,
    x2: 135.31,
    y2: 53.71
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.87 56.78)"
  }, "# Bottom Members"), /*#__PURE__*/React.createElement("polygon", {
    points: "84.81 149.82 84.84 150.6 85.42 151.13 86.2 151.1 86.73 150.53 86.7 149.74 86.12 149.21 85.34 149.25 84.81 149.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "84.81 149.82 84.84 150.6 85.42 151.13 86.2 151.1 86.73 150.53 86.7 149.74 86.12 149.21 85.34 149.25 84.81 149.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "84.81 149.82 84.84 150.6 85.42 151.13 86.2 151.1 86.73 150.53 86.7 149.74 86.12 149.21 85.34 149.25 84.81 149.82"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 139.34,
    y1: 169.86,
    x2: 158.8,
    y2: 169.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 85.77,
    y1: 150.17,
    x2: 139.34,
    y2: 169.86
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(161.87 172.93)"
  }, "Fill Material"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFramedWallLayer);
export default __webpack_public_path__ + "static/media/IconFramedWallLayer.530c96dc46f4b3fa058eefae4f66c06b.svg";
export { ForwardRef as ReactComponent };